<template>
  <div class="advice-list-container">
    <div v-show="refreshing" class="loading">加载中...</div>
    <van-pull-refresh v-model="refreshing" @refresh="getRecommend(true)" >
    <van-list
      :finished="finished"
      :error="error"
      finished-text="没有更多了"
      @load="getRecommend"
    >
      <div class="block appraise-content" v-for="item in recommendLists" :key="item" @click="goLink(item.id)">
        <div class="appraise-content-title">
          <div class="patient-info">
            <img class="patient-avatar" :src="item.headImgUrl || 'https://dsl-ds.oss-cn-shenzhen.aliyuncs.com/FEBD5F8207794C838A9D02AE764023D2.png'">
            <div class="patient-name">{{ item.patientName }}</div>
            <div :class="['patient-channel', getMed(item.isBook).class]">{{ getMed(item.isBook).name }}</div>
          </div>
          <van-rate
            v-model="item.scope"
            :count="5"
            :size="15"
            :gutter="2"
            color="#FFCA1E"
            void-icon="star"
            void-color="#eee"
            readonly
            allow-half
          />
        </div>
        <div class="desc-list">
          <div class="desc-item" v-for="des in item.labelList" :key="des">{{ des }}</div>
        </div>
        <div class="appraise-info">{{ item.context || `用户给出了${item.scope}星评价` }}</div>
        <div class="appraise-date">{{ item.createTimeStr }}</div>
      </div>
    </van-list>
  </van-pull-refresh>
  </div>
</template>

<script>
import haiNanHttp from '@/api/haiNan';

export default {
  data() {
    return {
      recommendLists: [],
      loading: false,
      finished: false,
      error: false,
      pageSize: 10,
      pageNo: 1,
      total: 0,
      refreshing: false,
    };
  },
  methods: {
    goLink(id) {
      if (this.$isInWxMP) {
        this.$wx.miniProgram.navigateTo({
          url: `/pages/comment/checkComment/index?orderId=${id}&commentType=patient`,
        });
      }
    },
    getMed(med) {
      switch (med) {
        case 0: return { name: '快速问诊', class: 'med-fast', };
        case 1: return { name: '图文问诊', class: 'med-teletext', };
        default: return '';
      }
    },
    // 获取患者评价
    async getRecommend(refreshing) {
      if (this.loading) return;
      this.loading = true;
      if (refreshing) {
        this.finished = false;
        this.error = false;
        this.pageNo = 1;
        this.recommendLists = [];
      }
      if (this.finished) return;
      /*eslint-disable*/
      let params = {
        doctorId: this.$route.query.id,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        select: 0,
      }
      const res = await haiNanHttp.get('/mp/commentController/listDoctorComment.do', {params});
      this.recommendLists = this.recommendLists.concat(res.data.list);
      this.total = res.data.total;
      this.pageNum = res.data.pageNum;
      this.refreshing = false;
      this.loading = false;
        // 判断是否加载完毕
        if (Number(res.data.total) <= this.recommendLists.length) {
          this.finished = true;
        } else {
          this.pageNo += 1;
        }
    },
  }
}
</script>

<style lang="scss" scoped>
.advice-list-container {
  margin-top: 15px;
  overflow: hidden;

  .loading {
    text-align: center;
    color: #666;
    font-size: 14px;
  }
}

.block {
  overflow: hidden;
  margin: 0 15px;
  padding: 15px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: $regular-border-radius;

  @include font(15px, 23px, #666);

  .skill {
    &:nth-child(1) {
      margin-bottom: 20px;
    }

    .skill-title {
      font-weight: 500;

      @include font(15px, 23px, $primary-text-color);
    }
  }
}

.appraise-content {
  margin-bottom: 12px;

  .appraise-content-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .patient-info {
      display: flex;
      align-items: center;

      .patient-avatar {
        width: 25px;
        height: 25px;
        border-radius: 50%;
      }

      .patient-name {
        margin: 0 12px;

        @include font(15px, 22px, $primary-text-color);
      }

      .patient-channel {
        background: #edffed;
        border-radius: 4px;

        @include font(12px, 17px, #3CB979);

        padding: 2px 6px;
        box-sizing: border-box;
      }

      .med-teletext {
        background: #eff5ff;
        color: #3d86ff;
      }

      .med-fast {
        background: #edffed;
        color: #07c164;
      }
    }
  }

  .desc-list {
    @include font(13px, 18px, #666);

    margin-top: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .desc-item {
      background: #f5f5f5;
      border-radius: 13px;

      @include font(13px, 18px, #666);

      padding: 4px 10px;
      box-sizing: border-box;
      margin-right: 10px;
      margin-bottom: 8px;
    }
  }

  .appraise-info {
    @include font(15px, 25px, $primary-text-color);

    margin-bottom: 8px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .appraise-date {
    @include font(12px, 17px, #999);
  }
}
</style>
